import Vue from 'vue'
import Vuex from 'vuex'

import test from './modules/test'
import plugins from './modules/plugins'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        test,
        plugins,
        auth,
    },
})